"use client"

const ConfirmationModal = ({
  showConfirmation,
  formData,
  currentRate,
  paymentAmount,
  selectedSiteBalance,
  paymentMethod,
  utrNumber,
  handleConfirmSubmit,
  handleCancel,
}) => {
  if (!showConfirmation) return null

  return (
    <div className="product-modal-overlay">
      <div className="confirmation-modal">
        <h4 className="fw-bold">Please review your details before submitting</h4>
        <p>
          <strong>Brand:</strong> {formData.brand}
        </p>
        <p>
          <strong>Grade:</strong> {formData.grade}
        </p>
        <p>
          <strong>Site Address:</strong> {formData.siteAddress?.address}, {formData.siteAddress?.state}
          {formData.siteAddress?.pincode && `, ${formData.siteAddress.pincode}`}
        </p>

        {/* Show Quantity only if selected */}
        {formData.quantity && (
          <p>
            <strong>Quantity:</strong> {formData.quantity} bags
          </p>
        )}

        {/* Show MT only if selected */}
        {formData.mt && (
          <p>
            <strong>MT:</strong> {formData.mt}
          </p>
        )}

        {currentRate && (
          <p>
            <strong>Rate:</strong> ₹{currentRate} per bag
          </p>
        )}

        <p>
          <strong>Payment Amount:</strong>{" "}
          {paymentAmount === "0.00" && selectedSiteBalance > 0
            ? "₹0.00 (Using existing balance)"
            : `₹${Number(paymentAmount).toLocaleString("en-IN")}`}
        </p>

        {paymentMethod === "utr" && utrNumber && (
          <p>
            <strong>UTR Number:</strong> {utrNumber}
          </p>
        )}

        {selectedSiteBalance > 0 && (
          <div className="balance-info">
            <p>
              <strong>Available Balance:</strong> ₹{selectedSiteBalance.toLocaleString("en-IN")}
            </p>
          </div>
        )}

        <div className="product-modal-buttons">
          <button onClick={handleConfirmSubmit} className="confirm-btn">
            Yes, Place Order
          </button>
          <button onClick={handleCancel} className="cancel-btn">
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmationModal
